module.exports = __webpack_public_path__ + "static/media/BricolageGrotesque-Light.a1f1439e.ttf";